module.exports = __webpack_public_path__ + "static/media/NX-Logo@2x.dadde092.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NX-Logo@2x.png
// module id = 626
// module chunks = 0